var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-button',{staticClass:"ma-0",attrs:{"medium":"","inline":"","color":"#ff842b","icon":"fa fa-chevron-left"},on:{"click":function($event){return _vm.goBack()}}},[_vm._v("\n  "+_vm._s(_vm.$t('menu.back'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }